import dayjs from "dayjs";

export const formatDate = (
  value: string | Date | null,
  format: string
): string => {
  return dayjs(value).format(format);
};
